import noUiSlider from "./nouislider.min.mjs";

class GenericSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const sliderEl = this.querySelector(".g-slider");
    const inputFrom = this.querySelector(".g-input--from");
    const inputTo = this.querySelector(".g-input--to");
    const hiddenContainer = this.querySelector(".g-hidden-inputs");

    const min = parseFloat(sliderEl.dataset.min);
    const max = parseFloat(sliderEl.dataset.max);
    const step = parseFloat(sliderEl.dataset.step || 1);
    const unit = sliderEl.dataset.unit || "";
    const paramName = sliderEl.dataset.param;

    const allValues = JSON.parse(sliderEl.dataset.values).map(parseFloat);

    const facetForm = document.querySelector("facet-filters-form form");
    const isRtl = document.documentElement.getAttribute("dir") === "rtl";

    noUiSlider.create(sliderEl, {
      start: [inputFrom.value, inputTo.value],
      connect: true,
      step,
      range: { min, max },
      direction: isRtl ? "rtl" : "ltr",
      tooltips: [true, true],
      format: wNumb({
        decimals: 2,
        thousand: "",
        suffix: unit ? ` ${unit}` : "",
      }),
    });

    const updateFacet = (values) => {
      const minVal = parseFloat(values[0]);
      const maxVal = parseFloat(values[1]);

      hiddenContainer.innerHTML = "";

      // Find all real (existing) values inside the dragged range — used only
      // to build the submitted filter params, never to override what the
      // user actually chose in the visible inputs.
      const selected = allValues.filter((v) => v >= minVal && v <= maxVal);

      inputFrom.value = minVal;
      inputTo.value = maxVal;

      function normalizeToStoredFormat(num) {
        if (Number.isInteger(num)) {
            return num.toFixed(1); // ensures format "1.0", "2.0"
        }
        return num.toString();   // 0.5 stays "0.5"
      }
      selected.forEach((v) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = paramName;
        input.value = normalizeToStoredFormat(v);
        hiddenContainer.appendChild(input);
        });

      facetForm.dispatchEvent(new Event("input"));
    };

    sliderEl.noUiSlider.on("change", updateFacet);

    inputFrom.addEventListener("change", () => {
      sliderEl.noUiSlider.set([inputFrom.value, null]);
      updateFacet(sliderEl.noUiSlider.get());
    });

    inputTo.addEventListener("change", () => {
      sliderEl.noUiSlider.set([null, inputTo.value]);
      updateFacet(sliderEl.noUiSlider.get());
    });

    let typedInputTimer;
    const handleTypedInput = () => {
      clearTimeout(typedInputTimer);
      typedInputTimer = setTimeout(() => {
        sliderEl.noUiSlider.set([inputFrom.value, inputTo.value]);
        updateFacet(sliderEl.noUiSlider.get());
      }, 400);
    };
    inputFrom.addEventListener("input", handleTypedInput);
    inputTo.addEventListener("input", handleTypedInput);
  }
}

customElements.define("generic-slider", GenericSlider);